import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "14",
  fill: "none",
  viewBox: "0 0 11 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#D9D9D9",
      "stroke-linejoin": "round",
      d: "M10.234 7 1.021.91.833 12.963z"
    }, null, -1)
  ]))]))
}
export default { render: render }